import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { MedicalJournalStatus, MedicalJournalStatusUtil } from '../../models/medicalCheckups/medicalJournalShortDto';

interface MedicalJournalStatusSelectProps {
    name: string;
    value: string | undefined;
    onChange: (event: SelectChangeEvent<string>) => void;
    includeAll?: boolean;
}

const MedicalJournalStatusSelect: React.FC<MedicalJournalStatusSelectProps> = ({ 
    name, 
    value, 
    onChange, 
    includeAll = true 
}) => {
    return (
        <FormControl variant="outlined" margin="dense" size="small" style={{ width: 200, marginRight: 10 }}>
            <InputLabel id="medical-journal-status-label">Статус</InputLabel>
            <Select
                labelId="medical-journal-status-label"
                id="medical-journal-status-select"
                name={name}
                value={value || ''}
                label="Статус"
                onChange={onChange}
                sx={{borderRadius: "10px",}}
            >
                {includeAll && (
                    <MenuItem value="all">Все</MenuItem>
                )}
                {Object.values(MedicalJournalStatus).map((status) => (
                    <MenuItem key={status} value={status}>
                        {MedicalJournalStatusUtil.getStringValue(status)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default MedicalJournalStatusSelect;
